var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _c("h2", [
        _vm._v(
          _vm._s(!_vm.booking.is_offer ? _vm.$t("Request") : `Offer`) +
            " Details\n       \n    "
        ),
        !(_vm.$userIsAdmin || _vm.$userIsIntern)
          ? _c(
              "button",
              {
                staticClass: "btn btn-plain-primary",
                on: { click: _vm.handleDownloadPdfCallback },
              },
              [
                _vm.downloading
                  ? _c("span", { staticClass: "pickstar-loading" })
                  : _c("span", [
                      _c("i", { staticClass: "fa fa-cloud-download" }),
                      _vm._v(" Download PDF"),
                    ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-item__row" },
        [
          _c("booking-field-input", {
            attrs: {
              booking: _vm.booking,
              "property-mutator": _vm.propertyMutator,
              field: "name",
              label: !_vm.booking.is_offer
                ? _vm.$t("Request")
                : `Offer` + " Name",
            },
          }),
          _vm._v(" "),
          !_vm.$vlastMode && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                staticStyle: { "text-transform": "capitalize" },
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "segment",
                  "field-type": "select",
                  options: _vm.segmentOptions,
                  label: "Segment",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vlastMode && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "organisation_name",
                  label: _vm._f("sentenceCase")(
                    _vm.$t("organisation") + " Name"
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.segment === "agency" && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "agency_stage",
                  value:
                    _vm.agencyStageOptions.findIndex(
                      (element) => element.id === _vm.booking.agency_stage
                    ) !== -1
                      ? _vm.agencyStageOptions.find(
                          (element) => element.id === _vm.booking.agency_stage
                        ).text
                      : "",
                  "other-field": "other_agency_stage",
                  "field-type": "select",
                  options: _vm.agencyStageOptions,
                  label: "Agency Stage",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeBudget &&
          (_vm.$userIsTalent || _vm.$userIsManager
            ? _vm.booking.budget_per_star_as_user_rate !== undefined
            : _vm.booking.budget_per_star !== undefined) &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  classes: "highlight",
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field:
                    _vm.$userIsTalent || _vm.$userIsManager
                      ? "budget_per_star_as_user_rate"
                      : "budget_per_star",
                  "field-type": "number",
                  currency: true,
                  "pre-text": _vm.budgetPreText,
                  "post-text": _vm.budgetPostText,
                  highlight: true,
                  label: _vm.budgetLabel,
                },
                scopedSlots: _vm._u(
                  [
                    _vm.booking.local_currency && !_vm.booking.is_offer
                      ? {
                          key: "after-info",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { on: { click: _vm.trackCurrencyClick } },
                                [_vm._v(_vm._s(_vm.conversionEstimate))]
                              ),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "required_stars",
                  "field-type": "number",
                  label: _vm._f("sentenceCase")(_vm.$starLabelPlural),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeBudget &&
          _vm.booking.budget_code &&
          !_vm.$isQas &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "budget_code",
                  label: "Budget Code",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeBudget &&
          _vm.booking.cost_centre &&
          _vm.$isQas &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "cost_centre",
                  label: "Cost Centre",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeBudget &&
          _vm.booking.gl_code &&
          _vm.$isQas &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "gl_code",
                  label: "GL Code",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          ((_vm.bookingAppearanceInPerson &&
            !_vm.booking.date_flexible_or_unconfirmed) ||
            (_vm.bookingAppearanceOnline && _vm.$vlastMode)) &&
          !_vm.$allowBookingDateRange
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "utc_date",
                  "field-type": "date",
                  label:
                    _vm.bookingAppearanceOnline && _vm.$vlastMode
                      ? _vm.booking.is_offer
                        ? "End Date"
                        : "Event Date"
                      : "In Person Event Date",
                  "show-booking-tz": true,
                },
              })
            : ((_vm.bookingAppearanceInPerson &&
                !_vm.booking.date_flexible_or_unconfirmed) ||
                (_vm.bookingAppearanceOnline && _vm.$vlastMode)) &&
              _vm.$allowBookingDateRange
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "date_range",
                  label:
                    _vm.bookingAppearanceOnline && _vm.$vlastMode
                      ? "Event Date"
                      : "In Person Event Date",
                  "show-booking-tz": false,
                  "show-tz": false,
                  editable: false,
                },
              })
            : _vm.bookingAppearanceInPerson &&
              _vm.booking.date_flexible_or_unconfirmed &&
              !_vm.booking.is_offer
            ? _c("booking-field-multiple-date", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  label: "In Person Event Date Options",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.appearance_type === "offer"
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "utc_date",
                  "field-type": "date",
                  label: "End Date",
                  "show-booking-tz": true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingAppearanceOnline &&
          !_vm.$vlastMode &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "complete_by_date",
                  "field-type": "date",
                  label: "Online Deliverables Complete By Date",
                  "show-tz": false,
                  "post-text":
                    _vm.booking.client && _vm.booking.client.timezone
                      ? `(${_vm.booking.client.timezone})`
                      : "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingAppearanceOnline && _vm.$vlastMode && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "video_url",
                  "field-type": "link",
                  label: "Video URL",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingAppearanceInPerson && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "arrival_time",
                  "field-type": "time",
                  label: "Arrival Time",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.bookingAppearanceInPerson ||
            (_vm.bookingAppearanceOnline && _vm.$vlastMode)) &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "athlete_start_time",
                  "field-type": "time",
                  label: "Start Time",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          ((_vm.bookingAppearanceInPerson && _vm.bookingHasLeaveTime) ||
            (_vm.bookingAppearanceOnline && _vm.$vlastMode)) &&
          !_vm.booking.is_offer
            ? [
                _c("booking-field-input", {
                  attrs: {
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "athlete_leave_time",
                    "field-type": "time",
                    label: "Leave Time",
                  },
                }),
                _vm._v(" "),
                _c("booking-field-input", {
                  attrs: {
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "event_duration",
                    label: "Event Duration",
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.travel_time && !_vm.$isNflClient && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "travel_time",
                  "field-type": "select",
                  options: _vm.opportunityDurationOptions,
                  label: "Travel Time",
                  value: _vm.booking.travel_time_formatted,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showDurationField && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "duration",
                  "field-type": "select",
                  options: _vm.opportunityDurationOptions,
                  label: "Speaking Time",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  editable: false,
                  field: "appearance_type",
                  value: _vm.bookingAppearanceType,
                  label: "Appearance Type",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.package &&
          _vm.booking.package.name &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  editable: false,
                  value: _vm.booking.package.name,
                  label: "Package",
                  "full-width": true,
                  "property-mutator": _vm.propertyMutator,
                  field: "",
                  booking: _vm.booking,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.aca_event_location && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "aca_event_location",
                  label: "Event Location",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.aca_event_distance && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "aca_event_distance",
                  label: "Distance",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.aca_event_gender && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "aca_event_gender",
                  label: "Event Gender",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.aca_number_participants && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "aca_number_participants",
                  label: "Number of Participants",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.aca_participant_ability && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "aca_participant_ability",
                  label: "Participant Ability",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  "full-width": true,
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "opportunities",
                  "field-type": "multi-select",
                  "multi-select-types": [
                    "appearance_type",
                    "theme",
                    "event_type",
                    "opportunity_type",
                  ],
                  label: "Event Summary",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("booking-field-input", {
            attrs: {
              "full-width": true,
              booking: _vm.booking,
              "property-mutator": _vm.propertyMutator,
              field: "description_formatted",
              "field-type": "textarea",
              label: !_vm.booking.is_offer
                ? _vm.$t("Request") + " Details"
                : `Offer Details`,
              html: "",
            },
          }),
          _vm._v(" "),
          _vm.bookingAppearanceInPerson &&
          _vm.$showDressCode &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  "full-width": true,
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  editable: false,
                  field: "dress_code",
                  label: "Dress Code",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.booking.requirements && !_vm.booking.is_offer
            ? _c(
                "booking-field-input",
                {
                  attrs: {
                    "full-width": true,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "requirements_formatted",
                    "field-type": "textarea",
                    label: _vm.$t("Request") + " Requirements",
                    html: "",
                  },
                },
                [
                  _vm.displayMarketingDisclaimer
                    ? _c(
                        "p",
                        {
                          staticClass: "requirements-info",
                          attrs: { slot: "after-info" },
                          slot: "after-info",
                        },
                        [
                          _vm._v(
                            "\n        Important: When talent are required to complete a promotional or branded post on their social media\n        accounts, it is likely this will need to be disclosed as advertising (e.g. #ad or #spon). To find out if\n        this is relevant to you, read more "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.socialMediaDisclosureLink,
                              },
                            },
                            [_vm._v("here")]
                          ),
                          _vm._v("\n        or email "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "mailto:" + _vm.$user.region.admin_email,
                              },
                            },
                            [_vm._v(_vm._s(_vm.$user.region.admin_email))]
                          ),
                          _vm._v(" if you have any questions.\n      "),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.bookingAppearanceInPerson
            ? [
                _c("booking-field-input", {
                  attrs: {
                    "full-width": true,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "location",
                    value: _vm.booking.address,
                    "field-type": "location",
                    label: "Location",
                  },
                }),
                _vm._v(" "),
                _c("booking-field-input", {
                  attrs: {
                    "full-width": true,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "additional_location_detail",
                    label: "Additional Location Detail",
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$categoryModuleEnabled && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "category_id",
                  "field-type": "select",
                  options: _vm.categoryOptions,
                  value: _vm.selectedCategory,
                  label: _vm.$t("Request Category"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode &&
          _vm.$isNrlClub &&
          _vm.$showDepartmentField &&
          !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "department_id",
                  "field-type": "select",
                  options: _vm.categoryOptions,
                  value: _vm.booking.department
                    ? _vm.booking.department.name
                    : "",
                  label: _vm._f("sentenceCase")(
                    _vm.$t("requesting department")
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$vlastMode && _vm.$isNflClient && !_vm.booking.is_offer
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "nfl_event_type",
                  label: "NFL Event",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  editable: false,
                  "field-type": "date",
                  field: "created_at",
                  label: "Created Date",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.booking.is_offer && _vm.$userIsAdmin
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  editable: false,
                  "field-type": "date",
                  field: "vetted_date",
                  label: "Vetted Date",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.booking.is_offer &&
          !_vm.bookingTypeIsBookingRequestOrDraft &&
          _vm.$userIsAdmin
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  editable: false,
                  "field-type": "date",
                  field: "scheduled_date",
                  label: "Booked Date",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.bookingTypeIsBookingRequestOrDraft &&
          _vm.$userIsAdmin &&
          _vm.bookingIsCompleted
            ? _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  editable: false,
                  "field-type": "date",
                  field: "completed_date",
                  label: "Completed Date",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$userIsAdmin && !_vm.booking.is_offer
            ? _c("div", { staticClass: "form-item__field" }, [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Assigned Admin"),
                    ]),
                    _vm._v(" "),
                    _vm.audience.length
                      ? _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "marketing_source_admin",
                            "disable-delete": true,
                            placeholder: "Unassigned",
                            options: _vm.audience,
                          },
                          model: {
                            value: _vm.stateAssignedAdmin,
                            callback: function ($$v) {
                              _vm.stateAssignedAdmin = $$v
                            },
                            expression: "stateAssignedAdmin",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$userIsAdmin && !this.$vlastMode && !_vm.booking.is_offer
            ? _c("div", { staticClass: "form-item__field" }, [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Revenue Category"),
                    ]),
                    _vm._v(" "),
                    _c("selectize", {
                      staticClass: "selectize selectize-single",
                      attrs: {
                        name: "revenue_category",
                        "disable-delete": true,
                        disabled: this.booking.type !== "request",
                        options: _vm.revenueCategoryOptions,
                      },
                      model: {
                        value: _vm.stateRevenueCategory,
                        callback: function ($$v) {
                          _vm.stateRevenueCategory = $$v
                        },
                        expression: "stateRevenueCategory",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          this.$vlastMode && _vm.booking.custom_fields && !_vm.booking.is_offer
            ? _vm._l(_vm.booking.custom_fields, function (field, index) {
                return _c("booking-field-input", {
                  key: field.name,
                  attrs: {
                    "full-width": true,
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: field.name,
                    value: field.value,
                    "field-type": field.dataType ? field.dataType : "text",
                    label: _vm.booking.custom_fields[index].name,
                    options: { fileUrl: field.file_url },
                  },
                })
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.booking.is_offer
            ? _c(
                "div",
                { staticClass: "more-details w-full spacer-t-4" },
                [
                  !_vm.$isNflClient
                    ? _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "location_unconfirmed",
                          label: "Location Unconfirmed",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$isNflClient
                    ? _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "date_flexible_or_unconfirmed",
                          label: "Flexible Date",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$isNflClient
                    ? _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "time_flexible_or_unconfirmed",
                          label: "Flexible Time",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("booking-field-boolean", {
                    attrs: {
                      booking: _vm.booking,
                      "property-mutator": _vm.propertyMutator,
                      field: "expenses_covered",
                      label: "Travel and Accommodation",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$hidePublicPromotingStatus
                    ? _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "promoted_publicly",
                          label: "Public Promoting",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$isNflClient
                    ? _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "budget_not_confirmed",
                          label: _vm._f("sentenceCase")(
                            _vm.$t("budget") + " Unconfirmed"
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$billboardModuleEnabled
                    ? _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          editable: _vm.$userIsAdmin,
                          field: "others_can_apply",
                          label: "Others Can Apply",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      (_vm.$userIsAdmin || _vm.$userIsClient) &&
      _vm.bookingHasCoupon &&
      !_vm.booking.is_offer
        ? _c("booking-field-input", {
            attrs: {
              booking: _vm.booking,
              "property-mutator": _vm.propertyMutator,
              field: "coupon",
              label: "Coupon Code",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingAppearanceInPerson &&
      _vm.bookingLatitudeAndLongitude &&
      !_vm.booking.is_offer
        ? _c(
            "div",
            { staticClass: "event-map" },
            [
              _c(
                "gmap-map",
                {
                  ref: "eventMap",
                  attrs: { center: _vm.bookingLatitudeAndLongitude, zoom: 10 },
                },
                [
                  _c("gmap-marker", {
                    attrs: { position: _vm.bookingLatitudeAndLongitude },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldSetSelected("video_message") && !_vm.booking.is_offer
        ? _c(
            "div",
            [
              _c("h2", [_vm._v("Video Message Details")]),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "video_caption_formatted",
                  "field-type": "textarea",
                  label: "Video Content",
                  "full-width": true,
                  html: "",
                },
              }),
              _vm._v(" "),
              !_vm.booking.commercial_purposes
                ? _c(
                    "div",
                    [
                      _c("booking-field-input", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "video_message_first_name",
                          label: "For (first name)",
                        },
                      }),
                      _vm._v(" "),
                      _c("booking-field-input", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "video_message_last_name",
                          label: "For (last name)",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.booking.commercial_purposes
                ? _c("booking-field-checkboxes", {
                    attrs: {
                      booking: _vm.booking,
                      "property-mutator": _vm.propertyMutator,
                      field: "video_message_places",
                      "other-field": "other_video_usage",
                      "other-value": _vm.videoMessageUsageLocationOptions[2].id,
                      "field-type": "select",
                      options: _vm.videoMessageUsageLocationOptions,
                      label: "Usage Locations",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.booking.commercial_purposes
                ? _c("booking-field-input", {
                    attrs: {
                      booking: _vm.booking,
                      "property-mutator": _vm.propertyMutator,
                      field: "video_rights_length",
                      "field-type": "select",
                      options: _vm.rightsLengthOptions,
                      label: "Rights Length",
                      "full-width": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "more-details" },
                [
                  _c("booking-field-boolean", {
                    attrs: {
                      booking: _vm.booking,
                      "property-mutator": _vm.propertyMutator,
                      field: "commercial_purposes",
                      label: "Commercial Purposes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldSetSelected("social_post") && !_vm.booking.is_offer
        ? _c(
            "div",
            [
              _c("h2", [_vm._v("Social Post Details")]),
              _vm._v(" "),
              _c(
                "booking-field-input",
                {
                  attrs: {
                    booking: _vm.booking,
                    "property-mutator": _vm.propertyMutator,
                    field: "post_caption_formatted",
                    "field-type": "textarea",
                    label: "Social Content",
                    html: "",
                  },
                },
                [
                  _vm.displayMarketingDisclaimer
                    ? _c(
                        "p",
                        {
                          staticClass: "requirements-info",
                          attrs: { slot: "after-info" },
                          slot: "after-info",
                        },
                        [
                          _vm._v(
                            "\n        Important: When talent are required to complete a promotional or branded post on their social media\n        accounts, it is likely this will need to be disclosed as advertising (e.g. #ad or #spon). To find out if\n        this is relevant to you, read more "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.socialMediaDisclosureLink,
                              },
                            },
                            [_vm._v("here")]
                          ),
                          _vm._v("\n        or email "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "mailto:" + _vm.$user.region.admin_email,
                              },
                            },
                            [_vm._v(_vm._s(_vm.$user.region.admin_email))]
                          ),
                          _vm._v(" if you have any questions.\n      "),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "number_of_social_media_posts",
                  "field-type": "number",
                  label: "Number of Social Media Posts",
                },
              }),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "social_post_location",
                  "field-type": "select",
                  options: _vm.socialLocationOptions,
                  label: "Social Post Location",
                },
              }),
              _vm._v(" "),
              _vm.booking.paid_advertising
                ? _c("booking-field-input", {
                    attrs: {
                      booking: _vm.booking,
                      "property-mutator": _vm.propertyMutator,
                      field: "rights_length",
                      "field-type": "select",
                      options: _vm.socialLengthOptions,
                      label: "Rights Length",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPaidAdvertising
                ? _c(
                    "div",
                    { staticClass: "more-details" },
                    [
                      _c("booking-field-boolean", {
                        attrs: {
                          booking: _vm.booking,
                          "property-mutator": _vm.propertyMutator,
                          field: "paid_advertising",
                          label: "Used In Paid Advertising",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fieldSetSelected("ambassador") && !_vm.booking.is_offer
        ? _c(
            "div",
            [
              _c("h2", [_vm._v("Brand Ambassador Details")]),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "ambassadorship_details_formatted",
                  "field-type": "textarea",
                  label: "Ambassadorship Details",
                  html: "",
                },
              }),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "target_market",
                  label: "Target Market",
                },
              }),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "ambassador_length",
                  "field-type": "select",
                  options: _vm.ambassadorLengthOptions,
                  label: "Ambassador Length",
                },
              }),
              _vm._v(" "),
              _c("booking-field-input", {
                attrs: {
                  booking: _vm.booking,
                  "property-mutator": _vm.propertyMutator,
                  field: "commencement_date",
                  "field-type": "date",
                  label: "Commencement Date",
                },
              }),
              _vm._v(" "),
              _vm.fieldSetSelected("marketing_campaign")
                ? [
                    _c("booking-field-input", {
                      attrs: {
                        booking: _vm.booking,
                        "property-mutator": _vm.propertyMutator,
                        field: "marketing_channels",
                        "field-type": "multi-select",
                        "multi-select-types": ["marketing_channel"],
                        label: "Marketing Channels",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "more-details" },
                      [
                        _c("booking-field-boolean", {
                          attrs: {
                            booking: _vm.booking,
                            "property-mutator": _vm.propertyMutator,
                            field: "shoot_required",
                            label: "Shoot Required",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }